import React, { useState } from "react";
import { Button } from "../../../../../../../../components/ui/Button";
import I18n from "../../../../../../../../core/localization/I18n";
import { useModalContext } from "../../../../../../../../core/modalZ/context/ModalContext";
import ProjectStakeholderOwnersApi from "../../../../../../../../services/api/v2/projectStakeholderOwners/ProjectStakeholderOwners.api";
import ProjectTeamUserPermissionsApi from "../../../../../../../../services/api/v2/projectTeamUserPermissions/ProjectTeamUserPermissions.api";
import { SingleFormModel } from "../../../../../../../change/forms/singleFormModel/SingleForm_model";
import { SingleForm } from "../../../../../../../change/forms/singleFormModel/SingleForm_view";
import { getStakeholderOwnerFormFields } from "./StakeholderOwnersSidebar_formFields";

interface ManageStakeholderOwnerFormProps {
  organisationId: number;
  projectId: number;
  projectStakeholder: FP.Entities.IProjectStakeholder;
  onAddOwner: () => void;
  pills: any;
}

class ManageStakeholderOwnerFormModel {
  formModel: SingleFormModel;

  constructor(
    organisationId: number,
    projectId: number,
    projectStakeholder: FP.Entities.IProjectStakeholder,
    onAddOwner: () => void
  ) {
    this.formModel = new SingleFormModel();

    const projectStakeholderOwnerProvider = ProjectStakeholderOwnersApi;
    const projectTeamUserPermissionsProvider = ProjectTeamUserPermissionsApi;
    let formFields = getStakeholderOwnerFormFields(
      projectStakeholderOwnerProvider,
      projectTeamUserPermissionsProvider,
      organisationId,
      projectId,
      projectStakeholder,
      onAddOwner
    );
    this.formModel.formFields = formFields;
  }
}

export const ManageStakeholderOwnerForm: React.FC<ManageStakeholderOwnerFormProps> = props => {
  const { projectStakeholder, projectId, organisationId, onAddOwner } = props;
  const modalService = useModalContext();

  let [model] = useState(
    () => new ManageStakeholderOwnerFormModel(organisationId, projectId, projectStakeholder, onAddOwner)
  );

  return (
    <div>
      <SingleForm model={model.formModel} />
      <div className="row mb-5">
        <div className="col">
          <div className="d-flex flex-column">
            <div className="row mb-3">{props.pills}</div>
            <Button
              className="ml-auto"
              onClick={() => {
                modalService.hide();
              }}
            >
              {I18n.t("phrases.done")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
